/**
 * Календарь праздников, выходных и переносов (SV-54).
 *
 * Пути лежат под `/control/departments/…`, потому что права — те же, что у графика
 * отдела (`departments/read|update|delete`): отдельного ресурса «календарь» нет ни
 * у одной роли.
 */
import {requestControl} from '@/shared/api';
import type {CalendarException, CalendarExceptionInput, CalendarList} from './types';

const BASE = '/control/departments/calendar';

/**
 * Записи за `[from, to]` (обе даты включительно, не больше 400 дней). С отделом —
 * его записи, записи его родителей и компании: ровно то, что действует на его людей.
 */
export async function fetchCalendar(
  companyId: string,
  {from, to, departmentId}: {from: string; to: string; departmentId?: string},
): Promise<CalendarException[]> {
  const params = new URLSearchParams({from, to});
  if (departmentId) {
    params.set('department_id', departmentId);
  }
  const res = await requestControl<CalendarList>(`${BASE}?${params.toString()}`, companyId);
  return res.items ?? [];
}

/** Создать или заменить запись на (отдел, дата) — повтор безопасен. */
export function putCalendarException(
  companyId: string,
  input: CalendarExceptionInput,
): Promise<CalendarException> {
  return requestControl<CalendarException>(BASE, companyId, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

export function deleteCalendarException(
  companyId: string,
  id: string,
): Promise<{deleted: boolean}> {
  return requestControl<{deleted: boolean}>(
    `${BASE}/${encodeURIComponent(id)}`,
    companyId,
    {method: 'DELETE'},
  );
}
